export default __webpack_public_path__ + "91920fb541e9e2d8dfc1dd90854a668a.png";